import React from 'react';
import classnames from 'classnames';
import BaseStatusTag, { IBaseStatusTagProps } from '../BaseStatusTag';
import { CONSTANT_TEXTS, StaticActionItemCodes, ACTION_ITEM_STATUS_LIST } from '@gp/constants/const';

import type { IRecord } from '@gp/types/global';
import type { IStatusTagCfg } from '../../types';

import './index.scss';

import GO_ICON from '@gp/assets/svg/goG/go.svg';
import NO_START_ICON from '@gp/assets/svg/detail-project-update/not-started.svg';
import REVIEWING_ICON from '@gp/assets/svg/goG/reviewing.svg';
import ON_HOLD_ICON from '@gp/assets/svg/detail-project-update/on-hold.svg';
import CANCELLED_ICON from '@gp/assets/svg/detail-project-update/cancelled.svg';

interface IActionItemStatusTagProps
  extends Omit<IBaseStatusTagProps, 'statusList' | 'statusMapping' | 'getStatusClassNames'> {}

export const GR_ACTION_ITEM_NAME_MAPPING: Record<string, string> = {
  [StaticActionItemCodes.Completed]: CONSTANT_TEXTS.COMPLETED,
  [StaticActionItemCodes.NotStarted]: CONSTANT_TEXTS.NOT_STARTED,
  [StaticActionItemCodes.InProgress]: CONSTANT_TEXTS.IN_PROGRESS,
  [StaticActionItemCodes.OnHold]: CONSTANT_TEXTS.ON_HOLD,
  [StaticActionItemCodes.Canceled]: CONSTANT_TEXTS.CANCELED,
};

const GR_ACTION_ITEM_STATUS_CFG_MAPPING: IRecord<IStatusTagCfg> = {
  [StaticActionItemCodes.Completed]: {
    text: GR_ACTION_ITEM_NAME_MAPPING[StaticActionItemCodes.Completed],
    icon: GO_ICON,
  },
  [StaticActionItemCodes.NotStarted]: {
    text: GR_ACTION_ITEM_NAME_MAPPING[StaticActionItemCodes.NotStarted],
    icon: NO_START_ICON,
  },
  [StaticActionItemCodes.InProgress]: {
    text: GR_ACTION_ITEM_NAME_MAPPING[StaticActionItemCodes.InProgress],
    icon: REVIEWING_ICON,
  },
  [StaticActionItemCodes.OnHold]: {
    text: GR_ACTION_ITEM_NAME_MAPPING[StaticActionItemCodes.OnHold],
    icon: ON_HOLD_ICON,
  },
  [StaticActionItemCodes.Canceled]: {
    text: GR_ACTION_ITEM_NAME_MAPPING[StaticActionItemCodes.Canceled],
    icon: CANCELLED_ICON,
  },
};

const getStatusClassNames = (isTag: boolean, status: string): IRecord<boolean> => ({
  'dbg-action-item-status-tag--completed': status === StaticActionItemCodes.Completed,
  'dbg-action-item-status-tag--not-started': status === StaticActionItemCodes.NotStarted,
  'dbg-action-item-status-tag--in-progress': status === StaticActionItemCodes.InProgress,
  'dbg-action-item-status-tag--on-hold': status === StaticActionItemCodes.OnHold,
  'dbg-action-item-status-tag--canceled': status === StaticActionItemCodes.Canceled,
});

const ActionItemStatusTag: React.FC<IActionItemStatusTagProps> = (props) => {
  const { className, isTag = false, ...restProps } = props;

  return (
    <BaseStatusTag
      {...restProps}
      isTag={isTag}
      className={classnames('dbg-action-item-status-tag', className)}
      statusList={ACTION_ITEM_STATUS_LIST as any[]}
      statusMapping={GR_ACTION_ITEM_STATUS_CFG_MAPPING}
      getStatusClassNames={getStatusClassNames}
    />
  );
};

export default ActionItemStatusTag;
